export const SHARE_PROJECT = '/project/:id/shared/:token'
